export default {
  filters: {
    capitalizeFirstLetter(text) {
      const convertedText = text.toString();
      return convertedText[0].toUpperCase() + convertedText.slice(1);
    },
  },
  methods: {
    generateRandomString(length) {
      let result = '';
      const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz123456789';
      const charactersLength = characters.length;
      for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
      }
      return result;
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/utility.js